import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableHead, Paper, Grid, TextField, IconButton, TableRow, TableCell, Button, Tooltip, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { DropzoneArea } from 'material-ui-dropzone';
import { useSnackbar } from 'notistack';
import { withRouter } from 'react-router';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { CkEditorText, DeletePopUp, STableLoader, PageLoader } from '../../../shared_elements';
import { checkApiStatus, onCheckFormPermission } from '../../../utils_v2';
import { globalGetService, globalPostService, globalFileUploadService, globalDeleteService } from '../../../globalServices';
import { trackActivity } from '../../../utils/mixpanel';
import { backendDateFormat, displayDateFormatShort, assetTypeId } from '../../../constants';

function Operator({ params, currentFormDetail, getResponseBackForm }) {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeltonLoader, setSkeltonLoader] = useState(true);
    const [data, setData] = useState({});
    const [initialValue] = useState('');
    const [formSave, setFormSave] = useState({ open: false, type: '', isdisabled: false });

    const SECTION_INFO = 'section_info';
    const SECTION_SHOP_VISIT = 'section_shop_visit';
    const SECTION_POWERPLANT = 'section_powerplant';
    const SECTION_FLEET = 'section_fleet';
    const SECTION_STRATEGY = 'section_strategy';
    const SECTION_REVIEWER = 'section_reviewer';

    const isSectionDisabled = (sectionType) => !onCheckFormPermission(currentFormDetail) || formSave?.type !== sectionType;

    const renderEditControls = (sectionType) => (
        <li className='list-inline-item' style={{ float: 'right',marginTop:'10px' }}>
            {!(formSave?.type === sectionType && formSave?.open) && (
                <Tooltip title='Edit' placement='top'>
                    <IconButton disabled={!onCheckFormPermission(currentFormDetail) || (formSave?.isdisabled && formSave?.type !== sectionType)} style={{ cursor: 'pointer' }} color='primary' size='small' onClick={() => setFormSave({ open: true, type: sectionType, isdisabled: true })}> <EditIcon /> </IconButton>
                </Tooltip>
            )}
            {formSave?.type === sectionType && formSave?.open && (
                <>
                    <Tooltip title='Cancel' placement='top'>
                        <Button style={{ marginInline: '5px' }} variant='outlined' color='primary' onClick={() => { getCurrentFormDetail(); setFormSave({ open: false, type: '', isdisabled: false }); }} size='small'> Cancel </Button>
                    </Tooltip>
                    <Tooltip title='Save' placement='top'>
                        <Button variant='contained' color='primary' onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '', isdisabled: false }); }} size='small'> Save </Button>
                    </Tooltip>
                </>
            )}
        </li>
    );

    const [modal, setModal] = useState({ open: false, data: null });
    const [files, setFiles] = useState([]);
    const [delteSignature, setDelteSignature] = useState({ modal: false, data: null, id: null });

    const opInfo = data || {};

    useEffect(() => {
        const fetchData = async () => {
            setSkeltonLoader(true);
            trackActivity('Project Management', {
                event_type: 'Page Visited',
                page_title: 'T015 Form Operator'
            });
            const currentData = await getCurrentFormDetail('skeltonLoader');
            if (!currentData?.id) {
                try {
                    const postResponse = await globalPostService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/operator/${assetTypeId[params?.type]}/`);
                    if (checkApiStatus(postResponse)) {
                        setData(postResponse?.data?.data);
                    } else {
                        enqueueSnackbar(postResponse?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                } catch (error) {
                    enqueueSnackbar('Failed to create data', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
            }
            setSkeltonLoader(false);
        };
        fetchData();
    }, [params?.workOrderSlug, params?.formSlug]);

    const getCurrentFormDetail = (loaderType) => {
        if (loaderType === 'noloader') {
            setSkeltonLoader(false); setLoading(false);
        } else if (loaderType) {
            setSkeltonLoader(true);
        } else {
            setLoading(true);
        }
        return globalGetService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/operator/${assetTypeId[params?.type]}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setData(response?.data?.data || {});
                    return response?.data?.data;
                }
                return null;
            })
            .catch(() => {
                enqueueSnackbar('Failed to fetch data', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                return null;
            })
            .finally(() => {
                if (loaderType === 'noloader') { setSkeltonLoader(false); setLoading(false); } else if (loaderType) { setSkeltonLoader(false); } else { setLoading(false); }
            });
    };

    const onFieldChange = (e, key, value, extraParam, index, date, nestedParam, nestedIndex) => {
        setData(prev => {
            if (extraParam) {
                return { ...prev, [extraParam]: { ...prev[extraParam], [key]: value } };
            }
            return { ...prev, [key]: value };
        });
    };

    const callthisapi = (itemData, neValue) => {
        setLoading(true);
        let payload = Object.assign({}, itemData ? itemData : data);
        if (neValue !== initialValue) {
            globalPostService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/operator/${assetTypeId[params?.type]}/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        setLoading(false);
                        getCurrentFormDetail();
                        getResponseBackForm();
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    }
                });
        } else {
            setLoading(false);
        }
    };

    const updateObjectArrayField = (arrayKey, index, key, value) => {
        debugger
        setData(prev => {
            const list = [...(prev?.[arrayKey] || [])];
            list[index] = { ...(list[index] || {}), [key]: value };
            return { ...prev, [arrayKey]: list };
        });
    };
    const addObjectArrayItem = (arrayKey, emptyObj) => {
        setData(prev => ({
            ...prev,
            [arrayKey]: [...(prev?.[arrayKey] || []), emptyObj]
        }));
    };
    const removeObjectArrayItem = (arrayKey, index) => {
        setData(prev => ({
            ...prev,
            [arrayKey]: (prev?.[arrayKey] || []).filter((_, i) => i !== index)
        }));
    };

    const digitalSigntureUpload = (uploadedFiles, fieldType) => {
        let formData = new FormData();
        if (uploadedFiles?.length) {
            uploadedFiles.forEach(item => {
                formData.append('files', item);
            });
        }
        setLoading(true);
        globalFileUploadService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/tct015operator/${data?.id}/attachment/${assetTypeId[params?.type]}/?field=${fieldType}`, formData)
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    getCurrentFormDetail();
                    getResponseBackForm();
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Project Management', {
                        event_type: 'Digital Signature Upload Success',
                        page_title: 'T015 Form Operator',
                        form_slug: params?.formSlug || '',
                        workOrder_slug: params?.workOrderSlug || '',
                        field_key: fieldType === 1 ? 'Inspector Digital Signature' : 'Reviewer Digital Signature',
                        success_msg: response?.data?.message
                    });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Project Management', {
                        event_type: 'Digital Signature Upload Failed',
                        page_title: 'T015 Form Operator',
                        form_slug: params?.formSlug || '',
                        workOrder_slug: params?.workOrderSlug || '',
                        field_key: fieldType === 1 ? 'Inspector Digital Signature' : 'Reviewer Digital Signature',
                        error_msg: response?.data?.message
                    });
                }
            });
    };

    const handleFileUpload = () => {
        digitalSigntureUpload(files, modal?.data);
        setModal({ open: false, data: null });
    };
    const handleDropzoneChange = (uploadedFiles) => {
        setFiles(uploadedFiles);
    };
    const onDeletePicture = () => {
        setLoading(true);
        globalDeleteService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/tct015operator/${data?.id}/attachment/${assetTypeId[params?.type]}/${delteSignature?.id}`)
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
                setDelteSignature({ modal: false, data: null, id: null });
                getCurrentFormDetail();
                getResponseBackForm();
                trackActivity('Project Management', {
                    event_type: delteSignature?.data === 1 ? 'Inspector Digital Signature' : 'Reviewer Digital Signature',
                    page_title: 'T015 Form Operator',
                    workOrderSlug: params?.workOrderSlug || '',
                });
            });
    };

    return (
        skeltonLoader ? <STableLoader count={5} rowsFill={7} /> :
            <section className='form-t015' style={{ marginTop: '112px' }}>
                <Paper square style={{ padding: '10px', marginBottom: '5px' }} elevation={2}>
                    <ul className='list-inline'>
                        <li className='list-inline-item'><h4>1. Operator Information</h4></li>
                        {renderEditControls(SECTION_INFO)}
                    </ul>

                    <Grid container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <h6 style={{ margin: '10px 0px 5px' }}>Last update:</h6>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    disabled
                                    margin='normal'
                                    id='last_update'
                                    format={displayDateFormatShort}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={opInfo?.updated_at || null}
                                    onChange={(date) => onFieldChange('', 'last_update', date ? moment(date).format(backendDateFormat) : null, '', '', 'date')}
                                    inputVariant='outlined'
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <h6 style={{ margin: '10px 0px 5px' }}>Operator</h6>
                            <TextField
                                variant='outlined'
                                fullWidth
                                margin='normal'
                                disabled={isSectionDisabled(SECTION_INFO)}
                                value={data?.operator_name || ''}
                                InputLabelProps={{ shrink: true }}
                                placeholder='Enter operator'
                                onChange={(e) => onFieldChange(e, 'operator_name', e.target.value)}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has shared a copy of their Air Operator Certificate (AOC) with the Inspector:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_INFO)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='aoc_shared'
                                value={['YES', 'NO'].filter(item => item === opInfo?.aoc_shared)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'aoc_shared', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has shared a copy of their Organisational Chart:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_INFO)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='org_chart_shared'
                                value={['YES', 'NO'].filter(item => item === opInfo?.org_chart_shared)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'org_chart_shared', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter details about the department structures and reporting lines...'
                                    disabled={isSectionDisabled(SECTION_INFO)}
                                    htmlData={opInfo?.department_structure_notes || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, department_structure_notes: value }))}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <span>The inspector is able to visit the engine technical records storage facility:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_INFO)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='records_facility_visitable'
                                value={['YES', 'NO'].filter(item => item === opInfo?.records_facility_visitable)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'records_facility_visitable', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <span>The (document) storage facility is adequately secured and fire protected:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_INFO)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='records_facility_secure'
                                value={['YES', 'NO'].filter(item => item === opInfo?.records_facility_secure)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'records_facility_secure', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <span>The physical engine records are stored on-site/off-site:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_INFO)}
                                options={['on-site', 'off-site']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '120px' }}
                                id='records_storage_location'
                                value={['on-site', 'off-site'].filter(item => item === opInfo?.records_storage_location)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'records_storage_location', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <span>The maintenance of physical engine records and data is managed by (team):</span>
                            <TextField
                                disabled={isSectionDisabled(SECTION_INFO)}
                                variant='outlined'
                                id='records_managed_by'
                                inputProps={{ maxLength: 100 }}
                                InputLabelProps={{ shrink: true }}
                                value={opInfo?.records_managed_by || ''}
                                onChange={(e) => onFieldChange(e, 'records_managed_by', e.target.value)}
                                placeholder='Enter...'
                                style={{ marginLeft: '5px', verticalAlign: 'middle' }}
                            />
                        </Grid>
                    </Grid>

                    <h5 style={{ margin: '15px 0px 10px' }}>1.1 General Comments on Tech Records Management:</h5>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter...'
                                    disabled={isSectionDisabled(SECTION_INFO)}
                                    htmlData={opInfo?.tech_records_management_comments || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, tech_records_management_comments: value }))}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has demonstrated a well-run technical department:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_INFO)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='well_run_technical_department'
                                value={['YES', 'NO'].filter(item => item === opInfo?.well_run_technical_department)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'well_run_technical_department', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter general summary of their technical efficiencies or lack thereof...'
                                    disabled={isSectionDisabled(SECTION_INFO)}
                                    htmlData={opInfo?.technical_efficiencies_summary || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, technical_efficiencies_summary: value }))}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <ul className='list-inline'>
                        <li className='list-inline-item'><h5 style={{ margin: '15px 0px 10px' }}>1.2 Shop Visit Information</h5></li>
                        {renderEditControls(SECTION_SHOP_VISIT)}
                    </ul>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has the following removal plan for next Shop Visits:</span>
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter...'
                                    disabled={isSectionDisabled(SECTION_SHOP_VISIT)}
                                    htmlData={opInfo?.shop_visit_removal_plan || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, shop_visit_removal_plan: value }))}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>uses the following MRO facilities:</span>
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter...'
                                    disabled={isSectionDisabled(SECTION_SHOP_VISIT)}
                                    htmlData={opInfo?.mro_facilities_used || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, mro_facilities_used: value }))}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <ul className='list-inline'>
                        <li className='list-inline-item'><h5 style={{ margin: '15px 0px 10px' }}>1.3 Powerplant Management</h5></li>
                        {renderEditControls(SECTION_POWERPLANT)}
                    </ul>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <span>The inspector has been provided with an overview of the systems used by </span>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_POWERPLANT)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='systems_overview_provided'
                                value={['YES', 'NO'].filter(item => item === opInfo?.systems_overview_provided)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'systems_overview_provided', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button disabled={isSectionDisabled(SECTION_POWERPLANT)} onClick={() => addObjectArrayItem('systems_used', { description: null, system_used: null, viewed: null })} color='primary' variant='contained' size='small' style={{ margin: '5px',float:'right' }}>+ ADD</Button>
                            <Table className='mui-table-format-t015'>
                                <TableHead className='table-align-head'>
                                    <TableRow>
                                        <TableCell><h6>Summary of systems:</h6></TableCell>
                                        <TableCell><h6>System used:</h6></TableCell>
                                        <TableCell><h6>Viewed</h6></TableCell>
                                        <TableCell/>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(opInfo?.systems_used || []).map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                <TextField
                                                    disabled={isSectionDisabled(SECTION_POWERPLANT)}
                                                    variant='outlined'
                                                    fullWidth
                                                    placeholder='Enter...'
                                                    inputProps={{ maxLength: 100 }}
                                                    value={item?.system_label || ''}
                                                    onChange={(e) => updateObjectArrayField('systems_used', index, 'system_label', e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    disabled={isSectionDisabled(SECTION_POWERPLANT)}
                                                    variant='outlined'
                                                    fullWidth
                                                    placeholder='Enter...'
                                                    inputProps={{ maxLength: 100 }}
                                                    value={item?.system_used || ''}
                                                    onChange={(e) => updateObjectArrayField('systems_used', index, 'system_used', e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Autocomplete
                                                    disabled={isSectionDisabled(SECTION_POWERPLANT)}
                                                    options={['viewed', 'not viewed', 'N/A']}
                                                    getOptionLabel={option => option}
                                                    value={item?.viewed || null}
                                                    onChange={(e, value) => updateObjectArrayField('systems_used', index, 'viewed', value)}
                                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin='normal' fullWidth />}
                                                />
                                            </TableCell>
                                            <TableCell align='center'>
                                                <Tooltip title='Delete' arrow>
                                                    <IconButton disabled={isSectionDisabled(SECTION_POWERPLANT)} color='secondary' onClick={() => removeObjectArrayItem('systems_used', index)}>
                                                        <DeleteOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>

                    <h5 style={{ margin: '15px 0px 10px' }}>1.4 General Comments on Powerplant Management</h5>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter...'
                                    disabled={isSectionDisabled(SECTION_POWERPLANT)}
                                    htmlData={opInfo?.powerplant_management_comments || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, powerplant_management_comments: value }))}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <ul className='list-inline'>
                        <li className='list-inline-item'><h5 style={{ margin: '15px 0px 10px' }}>1.5 Fleet Composition</h5></li>
                        {renderEditControls(SECTION_FLEET)}
                    </ul>
                    <Grid container spacing={1}>
                        <Grid item xs={11}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has discussed their current fleet composition:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_FLEET)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='fleet_composition_discussed'
                                value={['YES', 'NO'].filter(item => item === opInfo?.fleet_composition_discussed)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'fleet_composition_discussed', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={1} style={{ textAlign: 'end' }}>
                            <Button disabled={isSectionDisabled(SECTION_FLEET)} onClick={() => addObjectArrayItem('fleet_composition', { aircraft_type: null, aircraft_quantity: null, engine_type: null, engine_quantity: null, ownership: null, spare_engines: null })} color='primary' variant='contained' size='small' style={{ margin: '5px' }}>+ ADD</Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Table className='mui-table-format-t015'>
                                <TableHead className='table-align-head'>
                                    <TableRow>
                                        <TableCell><h6>A/C Type</h6></TableCell>
                                        <TableCell><h6>Quantity</h6></TableCell>
                                        <TableCell><h6>Engine Type</h6></TableCell>
                                        <TableCell><h6>Quantity</h6></TableCell>
                                        <TableCell><h6>Owned/Leased</h6></TableCell>
                                        <TableCell><h6>Spare Engines</h6></TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(opInfo?.fleet_composition || []).map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                <TextField disabled={isSectionDisabled(SECTION_FLEET)} variant='outlined' fullWidth placeholder='Enter...' inputProps={{ maxLength: 50 }} value={item?.aircraft_type || ''} onChange={(e) => updateObjectArrayField('fleet_composition', index, 'aircraft_type', e.target.value)} />
                                            </TableCell>
                                            <TableCell>
                                                <TextField disabled={isSectionDisabled(SECTION_FLEET)} variant='outlined' fullWidth placeholder='Enter...' inputProps={{ maxLength: 5 }} value={item?.aircraft_quantity || ''} onChange={(e) => { if (/^\d*$/.test(e.target.value)) updateObjectArrayField('fleet_composition', index, 'aircraft_quantity', e.target.value) }} />
                                            </TableCell>
                                            <TableCell>
                                                <TextField disabled={isSectionDisabled(SECTION_FLEET)} variant='outlined' fullWidth placeholder='Enter...' inputProps={{ maxLength: 50 }} value={item?.engine_type || ''} onChange={(e) => updateObjectArrayField('fleet_composition', index, 'engine_type', e.target.value)} />
                                            </TableCell>
                                            <TableCell>
                                                <TextField disabled={isSectionDisabled(SECTION_FLEET)} variant='outlined' fullWidth placeholder='Enter...' inputProps={{ maxLength: 5 }} value={item?.engine_quantity || ''} onChange={(e) => { if (/^\d*$/.test(e.target.value)) updateObjectArrayField('fleet_composition', index, 'engine_quantity', e.target.value) }} />
                                            </TableCell>
                                            <TableCell>
                                                <Autocomplete
                                                    disabled={isSectionDisabled(SECTION_FLEET)}
                                                    options={['Owned', 'Leased']}
                                                    getOptionLabel={option => option}
                                                    value={item?.ownership || null}
                                                    onChange={(e, value) => updateObjectArrayField('fleet_composition', index, 'ownership', value)}
                                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin='normal' fullWidth />}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField disabled={isSectionDisabled(SECTION_FLEET)} variant='outlined' fullWidth placeholder='Enter...' inputProps={{ maxLength: 50 }} value={item?.spare_engines || ''} onChange={(e) => updateObjectArrayField('fleet_composition', index, 'spare_engines', e.target.value)} />
                                            </TableCell>
                                            <TableCell align='center'>
                                                <Tooltip title='Delete' arrow>
                                                    <IconButton disabled={isSectionDisabled(SECTION_FLEET)} color='secondary' onClick={() => removeObjectArrayItem('fleet_composition', index)}>
                                                        <DeleteOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>

                    <h5 style={{ margin: '15px 0px 10px' }}>1.6 Spare Engine Support</h5>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has expressed requirements for further spare engine support:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_FLEET)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='spare_engine_support_required'
                                value={['YES', 'NO'].filter(item => item === opInfo?.spare_engine_support_required)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'spare_engine_support_required', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <span>Sales and Marketing have been made aware of this requirement:</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_FLEET)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='sales_marketing_aware'
                                value={['YES', 'NO'].filter(item => item === opInfo?.sales_marketing_aware)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'sales_marketing_aware', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='If yes.. Provide details...'
                                    disabled={isSectionDisabled(SECTION_FLEET)}
                                    htmlData={opInfo?.spare_engine_support_details || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, spare_engine_support_details: value }))}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <ul className='list-inline'>
                        <li className='list-inline-item'><h5 style={{ margin: '15px 0px 10px' }}>1.7 Operator Strategy</h5></li>
                        {renderEditControls(SECTION_STRATEGY)}
                    </ul>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has discussed their preservation strategies and planning. (y/n)</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_STRATEGY)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='preservation_strategy_discussed'
                                value={['YES', 'NO'].filter(item => item === opInfo?.preservation_strategy_discussed)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'preservation_strategy_discussed', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='If yes.. Provide details...'
                                    disabled={isSectionDisabled(SECTION_STRATEGY)}
                                    htmlData={opInfo?.preservation_strategy_details || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, preservation_strategy_details: value }))}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has discussed their maintenance cost strategies. (y/n)</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_STRATEGY)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='maintenance_cost_strategy_discussed'
                                value={['YES', 'NO'].filter(item => item === opInfo?.maintenance_cost_strategy_discussed)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'maintenance_cost_strategy_discussed', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='If yes.. Provide details...'
                                    disabled={isSectionDisabled(SECTION_STRATEGY)}
                                    htmlData={opInfo?.maintenance_cost_strategy_details || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, maintenance_cost_strategy_details: value }))}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has discussed their Flight Route Network. (y/n)</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_STRATEGY)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='route_network_discussed'
                                value={['YES', 'NO'].filter(item => item === opInfo?.route_network_discussed)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'route_network_discussed', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='If yes.. Provide details...'
                                    disabled={isSectionDisabled(SECTION_STRATEGY)}
                                    htmlData={opInfo?.route_network_details || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, route_network_details: value }))}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField variant='outlined' disabled value={data?.operator_name || ''} InputLabelProps={{ shrink: true }} placeholder='Enter' size='small' />
                            <span className='span-style'>has discussed their expansion plan. (y/n)</span>
                            <Autocomplete
                                disabled={isSectionDisabled(SECTION_STRATEGY)}
                                options={['YES', 'NO']}
                                getOptionLabel={option => option}
                                style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                                id='expansion_plan_discussed'
                                value={['YES', 'NO'].filter(item => item === opInfo?.expansion_plan_discussed)[0] || null}
                                onChange={(e, value) => onFieldChange(e, 'expansion_plan_discussed', value)}
                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin='normal' fullWidth />}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='If yes.. Provide details...'
                                    disabled={isSectionDisabled(SECTION_STRATEGY)}
                                    htmlData={opInfo?.expansion_plan_details || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, expansion_plan_details: value }))}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <h5 style={{ margin: '15px 0px 10px' }}>1.8 General Comments on Operator Strategies</h5>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter...'
                                    disabled={isSectionDisabled(SECTION_STRATEGY)}
                                    htmlData={opInfo?.operator_strategy_comments || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, operator_strategy_comments: value }))}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <h5 style={{ margin: '15px 0px 10px' }}>1.9 Additional Comments / Highlights / Concerns</h5>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter...'
                                    disabled={isSectionDisabled(SECTION_STRATEGY)}
                                    htmlData={opInfo?.additional_comments || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, additional_comments: value }))}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <h5 style={{ margin: '15px 0px 10px' }}>Report Details</h5>
                     {renderEditControls(SECTION_REVIEWER)}
                    <ul className='list-inline'>
                        <li className='list-inline-item'>
                            <h6 style={{ margin: '10px 0px 10px' }}>Report Completed By:</h6>
                        </li>
                        <li className='list-inline-item' style={{ display: 'inline-flex' }}>
                            <TextField
                                style={{ width: '250px', marginLeft: '20px' }}
                                disabled={isSectionDisabled(SECTION_REVIEWER)}
                                variant='outlined'
                                margin='normal'
                                id='report_completed_by'
                                inputProps={{ maxLength: 100 }}
                                InputLabelProps={{ shrink: true }}
                                value={opInfo?.report_completed_by || ''}
                                onChange={(e) => onFieldChange(e, 'report_completed_by', e.target.value)}
                                placeholder='Enter...'
                            />
                        </li>
                    </ul>
                    <ul className='list-inline'>
                        <li className='list-inline-item'>
                            <h6 style={{ margin: '15px 0px 15px' }}>Report Completion Date:</h6>
                        </li>
                        <li className='list-inline-item' style={{ display: 'inline-flex' }}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    disabled={isSectionDisabled(SECTION_REVIEWER)}
                                    margin='normal'
                                    id='report_completion_date'
                                    format={displayDateFormatShort}
                                    style={{ width: '250px', marginLeft: '2px' }}
                                    InputLabelProps={{ shrink: true }}
                                    value={opInfo?.report_completion_date || null}
                                    onChange={(date) => onFieldChange('', 'report_completion_date', date ? moment(date).format(backendDateFormat) : null, '', '', 'date')}
                                    inputVariant='outlined'
                                />
                            </MuiPickersUtilsProvider>
                        </li>
                    </ul>
                    <ul className='list-inline'>
                        <li className='list-inline-item'>
                            <h6 style={{ margin: '10px 0px 10px' }}>Report Reviewed By:</h6>
                        </li>
                        <li className='list-inline-item' style={{ display: 'inline-flex' }}>
                            <TextField
                                disabled={isSectionDisabled(SECTION_REVIEWER)}
                                variant='outlined'
                                margin='normal'
                                style={{ width: '250px', marginLeft: '31px' }}
                                id='report_reviewed_by'
                                inputProps={{ maxLength: 100 }}
                                InputLabelProps={{ shrink: true }}
                                value={opInfo?.report_reviewed_by || ''}
                                onChange={(e) => onFieldChange(e, 'report_reviewed_by', e.target.value)}
                                placeholder='Enter...'
                            />
                        </li>
                    </ul>
                    <ul className='list-inline'>
                        <li className='list-inline-item'>
                            <h6 style={{ margin: '15px 0px 15px' }}>Review Completion Date:</h6>
                        </li>
                        <li className='list-inline-item' style={{ display: 'inline-flex' }}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    disabled={isSectionDisabled(SECTION_REVIEWER)}
                                    margin='normal'
                                    id='review_completion_date'
                                    format={displayDateFormatShort}
                                    style={{ width: '250px' }}
                                    InputLabelProps={{ shrink: true }}
                                    value={opInfo?.review_completion_date || null}
                                    onChange={(date) => onFieldChange('', 'review_completion_date', date ? moment(date).format(backendDateFormat) : null, '', '', 'date')}
                                    inputVariant='outlined'
                                />
                            </MuiPickersUtilsProvider>
                        </li>
                    </ul>

                    <ul className='list-inline'>
                        <li className='list-inline-item'><h5 style={{ margin: '15px 0px 10px' }}>1.10 Reviewer Additional Comments / Highlights / Concerns</h5></li>
                        
                    </ul>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} sm={12}>
                            <div>
                                <CkEditorText
                                    placeholder='Enter...'
                                    disabled={isSectionDisabled(SECTION_REVIEWER)}
                                    htmlData={opInfo?.reviewer_comments || ''}
                                    onChangeData={(value) => setData(prev => ({ ...prev, reviewer_comments: value }))}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                        <Grid item xs={12} md={4} sm={4}>
                            <h5 style={{ margin: '5px 0px 10px' }}>Inspector Signature:</h5>
                            {data?.inspector_digital_signature?.map((items, index) => (
                                <div key={index}>
                                    <Paper square elevation={1} style={{ height: '40px', margin: '0px 10px 0px' }}>
                                        <div className='dropped-picture-cta' style={{ background: 'rgba(255, 255, 255, 0.5) ' }}>
                                            {!onCheckFormPermission(currentFormDetail) ? null : <Tooltip title='Delete'>
                                                <IconButton disabled={formSave?.isdisabled} onClick={() => setDelteSignature({ modal: true, data: 1, id: items?.id })} style={{ float: 'right' }}>
                                                    <DeleteOutlineIcon color={formSave?.isdisabled ? '' : 'secondary'} fontSize='small' style={{ cursor: 'pointer' }} />
                                                </IconButton>
                                            </Tooltip>}
                                        </div>
                                    </Paper>
                                    <div className='dropped-pic-card' style={{ backgroundSize: 'cover', backgroundImage: 'url(' + items?.url + ')', width: 'auto', height: '208px', border: 'groove 1px', borderColor: 'lightgray', margin: '0px 10px 10px 10px', padding: '2px' }}></div>
                                </div>
                            ))}
                        </Grid>
                        <Grid item xs={12} md={2} sm={2} style={{ float: 'right', marginTop: '5px' }}>
                            <Button onClick={() => setModal({ open: true, data: 1 })} disabled={data?.inspector_digital_signature?.length || formSave?.isdisabled} variant='outlined' color='primary'>Upload Signature</Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={4} sm={4}>
                            <h5 style={{ margin: '5px 0px 10px' }}>Reviewer Signature:</h5>
                            {data?.reviewer_digital_signature?.map((items, index) => (
                                <div key={index}>
                                    <Paper square elevation={1} style={{ height: '40px', margin: '0px 10px 0px' }}>
                                        <div className='dropped-picture-cta' style={{ background: 'rgba(255, 255, 255, 0.5) ' }}>
                                            {!onCheckFormPermission(currentFormDetail) ? null : <Tooltip title='Delete'>
                                                <IconButton disabled={formSave?.isdisabled} onClick={() => setDelteSignature({ modal: true, data: 2, id: items?.id })} style={{ float: 'right' }}>
                                                    <DeleteOutlineIcon color={formSave?.isdisabled ? '' : 'secondary'} fontSize='small' style={{ cursor: 'pointer' }} />
                                                </IconButton>
                                            </Tooltip>}
                                        </div>
                                    </Paper>
                                    <div className='dropped-pic-card' style={{ backgroundSize: 'cover', backgroundImage: 'url(' + items?.url + ')', width: 'auto', height: '208px', border: 'groove 1px', borderColor: 'lightgray', margin: '0px 10px 10px 10px', padding: '2px' }}></div>
                                </div>
                            ))}
                        </Grid>
                        <Grid item xs={12} md={2} sm={2} style={{ float: 'right', marginTop: '5px' }}>
                            <Button onClick={() => setModal({ open: true, data: 2 })} disabled={data?.reviewer_digital_signature?.length || formSave?.isdisabled} variant='outlined' color='primary'>Upload Signature</Button>
                        </Grid>
                    </Grid>
                </Paper>

                {modal?.open ?
                    <Dialog open={true} onClose={() => setModal({ open: false, data: null })}>
                        <DialogTitle id='scroll-dialog-title'>Upload Signature</DialogTitle>
                        <DialogContent dividers={true}>
                            <div style={{ width: '380px' }}>
                                <DropzoneArea
                                    filesLimit={1}
                                    maxFileSize={104857600}
                                    showPreviewsInDropzone={false}
                                    useChipsForPreview={true}
                                    acceptedFiles={['.png, .jpg, .jpeg, .heif, .heic']}
                                    showPreviews={true}
                                    dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                    dropzoneClass='drag-drop-cnt'
                                    maxWidth='sm'
                                    showAlerts={['info', 'error']}
                                    alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                    clearOnUnmount={true}
                                    onChange={handleDropzoneChange}
                                />
                            </div>
                            <span className='attachment-note'> Note :File upload limit is 1 in single time.</span>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setModal({ open: false, data: null })} color='primary' size='small' variant='outlined'>Close</Button>
                            <Button onClick={handleFileUpload} disabled={files?.length > 0 ? false : true} color='primary' size='small' variant='contained'>Proceed</Button>
                        </DialogActions>
                    </Dialog> : null}

                {delteSignature?.modal ?
                    <DeletePopUp
                        modal={delteSignature?.modal}
                        title={delteSignature?.data === 1 ? 'Inspector Signature' : 'Reviewer Signature'}
                        content='Are you sure, you want to Delete?'
                        toggleModalFn={() => setDelteSignature({ modal: false, data: null, id: null })}
                        deleteRecordFn={onDeletePicture}
                    /> : null}
                {isLoading ? <PageLoader /> : null}
            </section>
    );
}

export default withRouter(Operator);
